import { Users } from 'lucide-react';
import { PatientCard } from './PatientCard';
import { PatientSearch } from './PatientSearch';
import { EmptyState } from '@/components/ui/EmptyState';
import { SkeletonCard } from '@/components/ui/Skeleton';
import type { Patient } from '@/types/patient';

interface PatientListProps {
  patients: Patient[];
  isLoading: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function PatientList({
  patients,
  isLoading,
  searchQuery,
  onSearchChange,
}: PatientListProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">
        <PatientSearch value={searchQuery} onChange={onSearchChange} disabled />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PatientSearch value={searchQuery} onChange={onSearchChange} />
      </div>

      {patients.length === 0 ? (
        <EmptyState
          icon={<Users className="h-12 w-12" />}
          title="No patients found"
          description={
            searchQuery
              ? 'Try adjusting your search criteria'
              : 'No patients have been added yet'
          }
        />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {patients.map((patient) => (
            <PatientCard
              key={patient.id}
              patient={patient}
            />
          ))}
        </div>
      )}
    </div>
  );
}
